import { Component, inject } from '@angular/core';
import { NurseryService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  NurseryCreateDto,
  NurseryDto,
  NurseryExcelDownloadDto,
  NurseryUpdateDto,
} from '../proxy/planning/dtos/nursery';
import { NURSERY_CONFIG, NURSERY_FIELDS } from './nursery.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-nursery',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, NurseryService, ConfirmationService],
  templateUrl: './nursery.html',
  styleUrl: './nursery.scss',
})
export class Nursery extends BaseHierarchicalCrudComponent<
  NurseryDto,
  NurseryCreateDto,
  NurseryUpdateDto,
  NurseryExcelDownloadDto
> {
  service = inject(NurseryService);
  config = NURSERY_CONFIG;
  fields = NURSERY_FIELDS;

  protected prepareUpdateDto(data: any, selected: NurseryDto): NurseryUpdateDto {
    return {
      name: data.name,
      locationId: data.locationId,
      nurseryTypeId: data.nurseryTypeId,
      zoneId: data.zoneId,
      costCenterId: data.costCenterId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Nursery';
  }
}
